export default __webpack_public_path__ + "static/media/island_5_with_objects.c4d88435.png";